import { keycloak } from '_lib/api/keycloak';
import { CssBaseline } from '@material-ui/core';
import React from 'react';
import { AuthProvider } from 'react-oidc-context';

import App from './app/app';

const AppWrapper = () => (
  <AuthProvider {...keycloak}>
    <CssBaseline />
    <App />
  </AuthProvider>
);

export default AppWrapper;
